const { defaultsDeep } = require("lodash");

const roamingFilter = new Vue({
    el: '#roamingFilter',
    data() {
        return {
            locale: 'ca',
            selected: null,
            companies: null,
            countries: null,
        }
    },
    mounted() {
        const section = document.getElementById('roamingFilter')
        if(section) {
            section.removeAttribute('hidden');
        }
        this.locale = document.getElementsByTagName('html')[0].getAttribute('lang');
        this.countries = JSON.parse(this.$el.dataset.countries)
    },
    watch: {
        selected: async function(val) {
           if (typeof val === 'object') {
                await this.getCompanies()
           }
        },
    },
    methods: {
        selectCountry: async function(country) {
            this.selected = country;
            await this.getCompanies();
        },
        getCompanies: async function(){
            const res = await axios.get('/api/v1/roaming/companies/' + this.selected.id,
                { timeout: 10000 }
            );
            this.companies = res['data'];
        }
    }
})
